import React, { ChangeEvent, FormEvent, useState } from "react";
import { UserData, useLoginMutation } from "../../app/services/auth";
import classes from "./LoginForm.module.css";
import { useNavigate } from "react-router-dom";
import MenuButton from "../Buttons/MenuButton";
import { ReactComponent as BimatterLogo } from "../../pages/styles/Images/bimatter_logo.svg";

function LoginForm() {
    const [user, setUser] = useState<UserData>({
        email: "",
        password: "",
        roles: "",
    });
    const [login] = useLoginMutation();
    const navigate = useNavigate();
    const submitHandle = (e: FormEvent) => {
        if (!user.email || !user.password) return;
        e.preventDefault();
        e.stopPropagation();
        login(user);
        navigate("/files");
    };
    const inputChangeHandle = (e: ChangeEvent) => {
        const target = e.target as HTMLInputElement;
        setUser({
            ...user,
            [target.name]: target.value,
        });
    };
    return (
        <div className={classes.form_wrap}>
            <form className={classes.form} onSubmit={submitHandle}>
                <BimatterLogo className={classes.bimatter_logo}></BimatterLogo>
                <input
                    className={classes.input}
                    type="email"
                    placeholder="email"
                    name="email"
                    onChange={inputChangeHandle}
                    value={user.email}
                />
                <input
                    className={classes.input}
                    type="password"
                    placeholder="password"
                    name="password"
                    onChange={inputChangeHandle}
                    value={user.password}
                />
                <div className={classes.butWrap}>
                    <MenuButton onClick={submitHandle}>Login</MenuButton>
                    <button
                        onClick={submitHandle}
                        style={{ display: "none" }}
                    ></button>
                    <MenuButton
                        onClick={() => {
                            window.open(
                                "mailto:bimatter@mail.com?subject=Request bimatter storage&body=Hello, i want to test bimatter storage!"
                            );
                        }}
                    >
                        Request accaunt
                    </MenuButton>
                    <MenuButton
                        onClick={() => {
                            navigate("/files");
                        }}
                    >
                        Back
                    </MenuButton>
                </div>
            </form>
        </div>
    );
}

export default LoginForm;
